import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLanguage } from "@/i18n/LanguageContext";
import useSEO from "@/hooks/useSEO";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import Jurisdictions from "@/components/landing/Jurisdictions";
import Process from "@/components/landing/Process";
import FAQ from "@/components/landing/FAQ";
import LeadFormWizard from "@/components/landing/LeadFormWizard";
import Footer from "@/components/landing/Footer";
import JurisdictionPage from "@/pages/JurisdictionPage";
import { jurisdictionPages } from "@/data/jurisdictionPages";
import ServicePage from "@/pages/ServicePage";
import { servicePages } from "@/data/servicePages";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import { blogPosts } from "@/data/blogPosts";
import ContactPage from "@/pages/ContactPage";

const Landing = () => {
  const { t } = useLanguage();
  useSEO({ title: t.seo.title, description: t.seo.description });
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 150);
  }, []);
  return (
    <div className="bg-paper">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Jurisdictions />
      <Process />
      <FAQ />
      <LeadFormWizard />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/ar" element={<Landing />} />
            {Object.keys(jurisdictionPages).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<JurisdictionPage slug={slug} />} />
            ))}
            {Object.keys(servicePages).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} />} />
            ))}
            <Route path="/insights" element={<BlogIndex />} />
            {Object.keys(blogPosts).map((slug) => (
              <Route key={slug} path={`/insights/${slug}`} element={<BlogPost slug={slug} />} />
            ))}
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
